module.exports = __webpack_public_path__ + "gb.svg?c0af635097d429c21cdd7ea7636d40d5";